import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import posed, { PoseGroup } from 'react-pose';
import Terms from 'components/Terms';
import ResendLink from 'components/ResendLink';
import { Footer, Progress, Step, Steps } from './Form.style';
import Error from '../Error';

const AnimateContainer = posed.div({
  enter: {},
  exit: {}
});
export default class Wizard extends React.Component {
  static propTypes = {
    initialValues: PropTypes.shape(),
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  };
  static Page = ({ children }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues || {}
    };
  }

  next = values =>
    this.setState(state => ({
      page: Math.min(state.page + 1, this.props.children.length - 1),
      values
    }));

  previous = () =>
    this.setState(state => ({
      page: Math.max(state.page - 1, 0)
    }));

  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  validate = values => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];
    return activePage.props.validate ? activePage.props.validate(values) : {};
  };

  handleSubmit = async values => {
    const { children } = this.props;
    const { page } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;
    let submitErrors = null;

    if (typeof activePage.props.onSubmit === 'function') {
      submitErrors = await activePage.props.onSubmit(values);
    }

    if (!submitErrors && !isLastPage) {
      this.next(values);
    }

    return submitErrors;
  };

  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page].props.children;
    const isLastPage = page === React.Children.count(children) - 1;
    const step = page + 1;
    const steps = React.Children.toArray(children).length - 1;
    const progress = (page * 100) / steps;
    const name = activePage.props.name;

    return (
      <Form
        initialValues={values}
        validate={this.validate}
        onSubmit={this.handleSubmit}
      >
        {({ handleSubmit, submitErrors = {}, form }) => {
          const fieldState = form.getFieldState(name) || {};
          const isErrorProgress =
            fieldState.touched &&
            (fieldState.error ||
              (submitErrors[name] && !fieldState.dirtySinceLastSubmit));

          return (
            <form onSubmit={handleSubmit}>
              <PoseGroup preEnterPose="preEnter">
                <AnimateContainer key={activePage.key}>
                  {activePage}
                </AnimateContainer>
              </PoseGroup>
              {activePage.props.autoSubmit && (
                <OnChange name={activePage.props.name}>
                  {() => {
                    if (!fieldState.error && !!fieldState.value) {
                      form.submit();
                    }
                  }}
                </OnChange>
              )}

              {!isLastPage && (
                <React.Fragment>
                  <React.Fragment>
                    <Progress progress={progress} isError={isErrorProgress} />

                    <Footer>
                      <Error name={name} />
                      <Steps>
                        Шаг&nbsp;
                        <PoseGroup preEnterPose="preEnter">
                          <Step key={step}>{step}</Step>
                        </PoseGroup>
                        &nbsp;/&nbsp;{steps}
                      </Steps>
                    </Footer>
                  </React.Fragment>
                  {step === 2 && <ResendLink />}
                  <Terms />
                </React.Fragment>
              )}
            </form>
          );
        }}
      </Form>
    );
  }
}
